import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';

import { useFeatureFlag } from './useFeatureFlag';
import { checkRequiredConfigurations } from '../constants/featureFlag';
import { CHANNELS_SET_CONFIGURATION } from '../store/reducers/channels';

export const STATUS = {
  OK: 'OK',
  MISSING: 'MISSING',
};

export function useRequiredRetailerIntegrationConfig() {
  const dispatch = useDispatch();
  const isEnabled = useFeatureFlag(checkRequiredConfigurations, false);

  const { missing_retailer_configurations: requiredConfigurations, retailer: currentRetailer } = useSelector(
    (state) => state.retailer.current,
  );

  const integrationType = useMemo(() => {
    if (!isEnabled || !currentRetailer || !requiredConfigurations) return null;

    if (!isEmpty(requiredConfigurations.orders)) {
      return currentRetailer.ecommerce_orders_integration_type;
    }

    if (!isEmpty(requiredConfigurations.products)) {
      return currentRetailer.ecommerce_products_integration_type;
    }

    return null;
  }, [requiredConfigurations, currentRetailer, isEnabled]);

  useEffect(() => {
    if (integrationType) {
      dispatch({
        type: CHANNELS_SET_CONFIGURATION,
        payload: {
          integrationType,
          data: null,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [integrationType]);

  return {
    retailerIntegrationConfigStatus: integrationType ? STATUS.MISSING : STATUS.OK,
    requiredConfigurations,
    integrationType,
  };
}
